/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import {Component, Input} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {InputAccessor} from '../input-accessor';

@Component({
    selector: 'ui-simple-select',
    template: require('./ui-simple-select.html'),
    styles: [require('./ui-simple-select.less')],
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: UiSimpleSelect, multi: true}
    ]
})
export class UiSimpleSelect extends InputAccessor {

    @Input() list: string[];

    public prepareValueHook() {}

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/ui-select/ui-simple-select.ts